import React, { useState, useMemo, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface Props {
    onChange: (htmlContent: string) => void;
    defaultContent?: string;
    height?: number;
}

export const RichTextEditor: React.FC<Props> = (props) => {
    const [value, setValue] = useState<string>(props.defaultContent ?? "");
    const seeded = useRef(false);

    // Seed the editor the first time non-empty defaultContent arrives (async data loads)
    useEffect(() => {
        if (!seeded.current && props.defaultContent) {
            setValue(props.defaultContent);
            seeded.current = true;
        }
    }, [props.defaultContent]);

    const modules = useMemo(() => ({
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["link"],
            ["clean"],
        ],
    }), []);

    const formats = [
        "header", "bold", "italic", "underline",
        "color", "background", "align", "list", "bullet", "indent", "link",
    ];

    const handleChange = (html: string) => {
        setValue(html);
        props.onChange(html);
    };

    return (
        <ReactQuill
            theme="snow"
            value={value}
            onChange={handleChange}
            modules={modules}
            formats={formats}
            style={{ height: props.height ?? 500, marginBottom: 50 }}
        />
    );
};
